import { RuleResult } from 'types/DeclarationP5'
import { CL198_COUNTRY_ADDRESS_POSTCODE_ONLY } from 'shared/ncts/common/constants'
import { removePrefix } from 'shared/ncts/common/classifier-util'
import { LocationOfGoods } from '../../common/types'

const C0382Validator = {
  validateHouseNumberRequirement: ({
    locationOfGoods,
  } : {
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    const country = removePrefix(locationOfGoods?.postcodeAddress?.country ?? null, 'COUNTRY_')
    if (country && CL198_COUNTRY_ADDRESS_POSTCODE_ONLY.includes(country)) {
      return 'OPTIONAL'
    }

    return 'REQUIRED'
  },
} as const

export default C0382Validator
